import {
    IonCheckbox,
    IonCol,
    IonInput,
    IonItem,
    IonLabel,
    IonRow,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import RequiredInputIndicator from "../Forms/RequiredInputIndicator";

interface _Props {
    initialFullName: string
    initialIsChecked: boolean
    onChange: (fullName: string, isChecked: boolean) => void;
}

const RuleAgreementForm: React.FC<_Props> = ({initialFullName, initialIsChecked, onChange}) => {

    const [fullName, setFullName] = useState<string>("");
    const [isChecked, setIsChecked] = useState<boolean | null>(null);

    useEffect(() => {
        // On mount, set the initial values
        if (fullName === "" && initialFullName !== "") setFullName(initialFullName);
        if (isChecked === null && initialIsChecked !== null) setIsChecked(initialIsChecked);
    }, []);

    const handleFullNameChange = (value: string) => {
        if (fullName !== initialFullName) onChange(fullName, isChecked || false);
        setFullName(value);
    }

    const handleIsCheckedChange = () => {
        const newIsChecked = !isChecked;
        if (newIsChecked !== initialIsChecked) onChange(fullName, newIsChecked);
        setIsChecked(newIsChecked);
    }

    return (
        <IonRow>
            <IonCol size="12">
                <IonRow>
                    <IonCol sizeXs="12" sizeMd="12">
                        <IonItem color="white">
                            <IonLabel position="stacked">Full Name <RequiredInputIndicator /></IonLabel>
                            <IonInput 
                                type="text"
                                value={fullName}
                                aria-required={true}
                                onIonChange={e => {
                                    handleFullNameChange(e.detail.value!);
                                }}
                            />
                        </IonItem>
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size="12">
                        <IonItem>
                            <IonCheckbox slot="start" checked={isChecked || false} color="success" onClick={() => handleIsCheckedChange()} />
                            <IonLabel className="ion-text-wrap">
                                <p className="text-primary">I have read and agree to the above rule. <RequiredInputIndicator /></p>
                            </IonLabel>
                        </IonItem>
                    </IonCol>
                </IonRow>
            </IonCol>
        </IonRow>
    );
};

export default RuleAgreementForm;